var React = require('react');
import { Box, Container, Grid } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import DeleteIcon from "@material-ui/icons/Delete";
import SearchIcon from "@material-ui/icons/Search";
import Button from "@mui/material/Button";
import SaveIcon from "@material-ui/icons/Save";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Toolbar from '@mui/material/Toolbar';
import CloseIcon from '@mui/icons-material/Close';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { muiThemeDesign } from '../../mui-theme-design';
import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import Fade from '@mui/material/Fade';
import moment from "moment";
import DataPivot from '../Table/DataPivot'
import { waitTimer } from '../waitTimer'
import { makeStyles } from "@mui/styles";
import {logger, customBodyForExcelReport,handleExport,checkAuthentication,muiLoaderOptions} from '../../utils';
const ExcelJS = require('exceljs');

const pageStyles = makeStyles(theme => ({
    root: {
        "& .MuiPaper-root": {
            overflowy: "hidden",
            color: '#ffffff'
        },
    }
}));
//const [newRoster, setNewRoster] = React.useState(false);

export default function ReportUserRoster({ handleClearRoster, openReport, newRoster, InactiveUsers, data }) {
    const [refresh, setRefresh] = React.useState(false);
    const [dataSet, setDataSet] = React.useState([]);
    const [open, setOpen] = React.useState(false);
    const [status, setStatus] = React.useState(false);
    const [PropTypePick, setPropTypePick] = React.useState([]);
    const [headers, setHeaders] = React.useState([]);
    const [customColumns, setCustomColumns] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(true)
    const timerRef = React.useRef (null);
    const classes = pageStyles();
        
  //  logger(`RosterIncoming`, data)
  //  logger(`RunReport`, newRoster)
 //   logger(`OpenReport`, openReport)
 //   logger(`ReportRefresh`, refresh)

    const [columns, setColumns] = React.useState([
        {
            name: "Last Name",
            label: "Last Name",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "First Name",
            label: "First Name",
            options: {
                filter: false,
                sort: true,
            }
        },
        {
		    name: "Role",
		    label: "Role",
		    options: {
		        filter: false,
		        sort: true,
		        customBodyRender: (value, tableMeta, updateValue) => {
		            const defaultRole = tableMeta.rowData[6]?.trim();
		            if (value) {
		                let roles = value.split(",").map(role => role.trim());
		                roles = roles.filter(role => role !== defaultRole);
		                roles.unshift(defaultRole);
		                logger("roles", roles);
		                return roles.map((role, idx) => {
		                    return (
		                        <div key={idx}>
		                            {role === defaultRole ? <b>{role}</b> : role}
		                            <br />
		                        </div>
		                    );
		                });
		            } else {
		                return (
		                    <div>
		                        {defaultRole}
		                    </div>
		                );
		            }
		        }
		    }
		},
        {
            name: "Email",
            label: "BCI Email",
            options: {
                filter: false,
                sort: true,
            }
        },
        {
            name: "CostCenter",
            label: "Cost Center",
            options: {
                filter: true,
                display: false,
                sort: false,
            }
        },
    ]) 

    const getSavedRowsPerPage = () => {
        const savedValue = localStorage.getItem('rowsPerPage');
        return savedValue ? parseInt(savedValue) : 100; // Default value
    }
    // Save to local storage
    const saveRowsPerPage = (value) => {
        localStorage.setItem('rowsPerPage', value.toString());
    }
    
    const arraymove = (arr, fromIndex, toIndex) => {
	    var element = arr[fromIndex];
	    arr.splice(fromIndex, 1);
	    arr.splice(toIndex, 0, element);
	}

    const initialRowsPerPage = getSavedRowsPerPage();

    const options = {
        filter: true,
        filterType: 'dropdown',
        responsive: 'standard',
        selectableRows: 'none',
        fixedHeader: true,
        fixedSelectColumn: false,
        rowsPerPage: initialRowsPerPage,
        rowsPerPageOptions: [10, 20, 50, 100],
        tableBodyHeight: "400px",
        tableBodyMaxHeight: "1000px",
        textLabels: {
			toolbar: {
			  search: "Search",
			  downloadCsv: "Download Excel", 
			  print: "Print",
			  viewColumns: "View Columns",
			  filterTable: "Filter Table",
				},
		},
		  onDownload: (buildHead, buildBody, columns, data) => {
			// Custom buildHead and buildBody functions
			const customBuildHead = () => {
				var newColumns = columns.map(column => column.label);
				return newColumns;
			}
		
			const customBuildBody = () => {
				const headers = customBuildHead();
				logger("headers", headers);
				var defaultRoleIndex = headers.indexOf("DefaultRole");
				var roleIndex = headers.indexOf("Role");
				arraymove(headers, defaultRoleIndex, roleIndex+1);
				logger("arraymove", arraymove)
				data.forEach(eachData => {
					arraymove(eachData.data, defaultRoleIndex, roleIndex+1);
				});
				return customBodyForExcelReport({data:data, headers:headers});
			};
			
			const headers = customBuildHead();
			const rows = customBuildBody();
			
			arraymove(headers, headers.indexOf("DefaultRole"), headers.indexOf("Role")+1);
			
			handleExport({rows:rows, headers:headers, filename: 'UserRoster.xlsx'});
			return false;
		}

};
       /* resizableColumns: true,
        selectableRowsOnClick: false,
        draggable: true,
        draggableColumns: {
            enabled: true},*/
    

  /*  function checkData(underTest) {
        if (underTest.length) {
            return (setStatus(true))
        }else (setStatus(false))
    }*/

    var useHeaders = [];
    var currentHeaders = [];
    var merge = [];
    var newColumns = [];
    var headerCount = [];
  //  var customColumns = []

    const processReport = React.useCallback(() => {
  //      logger(`processReport`, data)
        const useProps = Object.values(data);

        const propString = useProps[0].map((p) => {
            return `user_prop_type.ID=${p}`
        }).join(" OR ");
     //   logger("in PropString " + propString)
        rosterData(propString)
      
    })
    const rosterData = async (string) => {
        logger("InactiveUsers", InactiveUsers)
        logger(`api/Reports/UserRoster/${string}/${InactiveUsers ? '0':'1'}`)
        await fetch(`api/Reports/UserRoster/${string}/${InactiveUsers ? '0':'1'}`, {
            method: 'Get',
        })
            .then(res => res.json())
            .then(json => DataPivot(json).then(res => {setDataSet(res);
            setIsLoading(false);
            }))
            
           .then(logger('rosterDataReturn', dataSet))
        //setRefresh(true)
    }

    function getHeaders(dataSet) {
        if (columns.length) {
            currentHeaders = columns.map(x => x.name);
            useHeaders = Object.keys(dataSet[0]);
     //       logger(`UH`, useHeaders)
         //   logger(`delete`.useHeaders["ID"])
         
            useHeaders = useHeaders.filter(function (e) {
                return e !== 'ID';
            });

          /*  bob = list.filter(function (e) {
                return e !== 'fish';
            });*/
            headerCount = useHeaders.length;
            useHeaders = useHeaders.filter(function (val) {
                return currentHeaders.indexOf(val) == -1;
            })
        }
      //  logger('Use ', useHeaders)
      //  logger('Current ', currentHeaders)
    }

    const genColumn = () => {
    //    if (!customColumns) {
       //     logger(`migration`)
        //    setCustomColumns(columns)
        //    logger(`Mcustom`, customColumns)
    //    }
        newColumns = [...columns];
    //   logger(`UH2`,useHeaders)
    //    logger(`in genColumn`)
        if (newColumns.length < headerCount) {
         //   newColumns = [...columns];
            for (var i = 0; i < useHeaders.length; i++) {
                newColumns.push(
                    {
                        name: useHeaders[i],
                        label: useHeaders[i],
                        options: {
                            filter: true,
                            sort: true,
							display: useHeaders[i] === "DefaultRole" ? false : true
                        }
                    }
                )
            }
        } else {
            setRefresh(false)
            setStatus(true)
            
        }
        setCustomColumns(newColumns)
    }

 /*   const handleClickOpen = () => {   
        setRefresh(true)
        if (doRun) {
            setOpen(true)
        }
    }*/
 /*   async function fixcolumns () {
        const fix = await (setColumns(newColumns)), {
            onErrror (`failed`)
            logger(`failed`)
        }
}*/
    
    
    const handleClose = () => {
     //   logger(`RR handleClose`)
        setOpen(false)
        setRefresh(false)
        setDataSet([])
    }
    const wait = () => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }
        if (!newColumns.length) {
            timerRef.current = setTimeout(() => {
                setRefresh(true)
             //   setNext(true)              
            }, 2000);
        }
    }
    React.useEffect(() => {
		checkAuthentication();
        if (!openReport) {
      //      logger(`RR NotOpen`)
            setRefresh(false)
            setOpen(false)
            setDataSet([])
        }

        if (refresh) {
     //       logger("in refresh")
          //  if (next) {
           //     logger(`nextTrue`)
            if (!dataSet.length) {
      //          logger(`step1`, data)
           
                    rosterData(data)
                }
                if (!dataSet.length) {
              //      logger(`step1 fail`)
                    setStatus(false)
                  //  setNext(false)
                    wait()
                    return
                } else {
                    if (!useHeaders.length) {
                        getHeaders(dataSet)
                    }
                }
                if (!useHeaders.length) {
      //             logger(`step2`)
                    setStatus(false)
                  //  setNext(false)
                    wait()
                    return
                } else {
                 //   if (!headers.length) {
      //               logger(`running genColumn`)
                        genColumn()
                 //   }
            }
            if (newColumns.length) {
                setStatus(true)
            }
        } else {
         //   logger(`data `, dataSet)
         //   logger(`ENDrefreshFalse`)
        }
        setRefresh(false);

        if (newRoster) {
    //        logger(`in doRun`)
         //   setRunRoster(true)
    //        logger(`IF Dataset`, dataSet.length)
            setOpen(true)
            newRoster =(false);
            //   logger(`ReportUE String`, propString)
            if (!dataSet.length) {
     //           logger(`in IF Dataset`, dataSet.length)
                setRefresh(true)

            }
            
        }
       /* if (!openReport) {
            setRefresh(false)
            setOpen(false)
            setDataSet([])
        }*/
    })
	
	/*const sortColumns = () => {
		var columnsOrder = ["Last Name","First Name", "Email", "Role", "HR Name"];
		var priorityColumns = [];
		var unsortedColumns = new Set();
		for (var i = 0; i < columnsOrder.length; i++) {
			for (var j = 0; j < customColumns.length; j++) {
				if (columnsOrder[i]===customColumns[j].name) {
					priorityColumns.push(customColumns[j]);
					break;
				}
			}
		}
		
		for (var j = 0; j < customColumns.length; j++) {
			if (!columnsOrder.includes(customColumns[j].name)) {
				priorityColumns.push(customColumns[j]);
			}
		}
		
		return priorityColumns;
	}*/

   /* const dialogDisplay = () => {    
        if (!status) {
            if (open) {
            //    logger(`in fail-wait`)
                return (
                    <Box sx={{ height: 300 }}>
                        <Fade
                            in={(!status)}
                            style={{
                                transitionDelay: status ? '800ms' : '0ms',
                            }}
                            unmountOnExit
                        >
                            <Stack sx={{ color: 'grey.500' }} spacing={2} direction="row" justifyContent="center">
                                <CircularProgress color="secondary" />
                                <CircularProgress color="success" />
                                <CircularProgress color="inherit" />
                            </Stack>
                        </Fade>
                    </Box>
                )
            }
        } else
              {
                
        //    logger(`rendering`)
        
                return (
                    <Box className={classes.root}>
                        <MuiThemeProvider theme={muiThemeDesign}>
                            <MUIDataTable className={classes.root}
                                title={
                                    <Typography variant="h6" style={{ color: "white" }}>
                                        <IconButton edge="start" color="inherit" onClick={handleClearRoster} aria-label="close"> <CloseIcon /> </IconButton>
                                        Beyondsoft Employee List
                                    </Typography>
                                }
                                data={dataSet}
                                //columns={sortColumns()}
                                columns={customColumns}
                                options={options}
                            />
                        </MuiThemeProvider>
                    </Box>

                )
            
            }
    //  }
    }*/
  /*  <Button variant="contained" onClick={handleClickOpen}>
        Generate Report
    </Button>*/

    options.onChangeRowsPerPage = (newRowsPerPage) => {
        saveRowsPerPage(newRowsPerPage);
    };

    return (<>
 
        <div>
            <Dialog className={classes.root} open={open} onClose={handleClose} fullWidth maxWidth="xl" scroll="paper" overflow-y="hidden">
                <DialogContent >                            
                         <Box className={classes.root}>
                        <MuiThemeProvider theme={muiThemeDesign}>
                            <MUIDataTable className={classes.root}
                                title={
                                    <Typography variant="h6" style={{ color: "white" }}>
                                        <IconButton edge="start" color="inherit" onClick={handleClearRoster} aria-label="close"> <CloseIcon /> </IconButton>
                                        Beyondsoft Employee List
                                    </Typography>
                                }
                                data={isLoading ? [] :dataSet}
                                columns={customColumns}
                                options={muiLoaderOptions(options, isLoading)}
                            />
                        </MuiThemeProvider>
                    </Box>
                        </DialogContent>
                    </Dialog>
                </div>
        </>
    );
}
